<div id="root">
  <div class="fixed-background">
    <main>
      <div class="container">
        <div class="row h-100">
          <div class="col-10 col-md-8 mx-auto my-auto" style="text-align: center;">
            <div class="card auth-card">
              <div class="form-side">
                <a routerLink="/">
                  <span class="logo-single"></span>
                </a>
                <h6 class="mb-4">{{ "pages.signed-out-title" | translate }}</h6>
                <p class="mb-5 text-muted">
                  {{ "pages.signed-out-message" | translate }}
                </p>
                <a routerLink="/user/login" class="btn btn-primary btn-lg btn-shadow mb-3">
                  {{ "pages.signed-out-sign-in" | translate | uppercase }}
                </a>
                <br>
                <a routerLink="/" class="btn btn-outline-primary btn-lg">
                  {{ "pages.go-back-home" | translate }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>
